import React from "react";
import styled from "styled-components";
import Button from "./Button";

const Container = styled.div`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	padding: 1rem;
`;

const Message = styled.span`
	font-size: 0.95rem;
	font-weight: 500;
	font-family: inherit;
	color: rgba(0, 0, 0, 0.7);
`;

const InlineRetry = ({ message, retry, retryButtonText, disabled }) => {
	return (
		<Container>
			<Message>{message || "Something went wrong"}</Message>
			{retry ? (
				<Button onClick={() => retry()} active height="36px" disabled={disabled} width="6rem">
					{retryButtonText || "Retry"}
				</Button>
			) : null}
		</Container>
	);
};

export default InlineRetry;
